import { Platform } from 'react-native';
const isAndroid = Platform.OS === 'android';

export default {
  ADMOB: {
    BANNER: isAndroid ? 'ca-app-pub-7233062590896994/9044211733' : 'ca-app-pub-7233062590896994/2009736388',
    FULL: isAndroid ? 'ca-app-pub-7233062590896994/1165721711' : 'ca-app-pub-7233062590896994/8383573041',
    NATIVE: isAndroid ? 'ca-app-pub-7233062590896994/5649410790' : 'ca-app-pub-7233062590896994/4527900815',
    REWARD: isAndroid ? 'ca-app-pub-/' : 'ca-app-pub-/',
    OPEN: isAndroid ? 'ca-app-pub-7233062590896994/2195732274' : 'ca-app-pub-7233062590896994/5205038992'
  }
};
